__turbopack_context__.v({
  "salary-time": "salary-input-module-scss-module__N7GzvG__salary-time",
  "salary-title": "salary-input-module-scss-module__N7GzvG__salary-title",
  "slider": "salary-input-module-scss-module__N7GzvG__slider",
  "slider-mark": "salary-input-module-scss-module__N7GzvG__slider-mark",
  "slider-thumb": "salary-input-module-scss-module__N7GzvG__slider-thumb",
  "slider-value": "salary-input-module-scss-module__N7GzvG__slider-value",
  "slider-wrapper": "salary-input-module-scss-module__N7GzvG__slider-wrapper",
});
